import { render } from "./PortalInicio.vue?vue&type=template&id=5513a3dc&scoped=true"
import script from "./PortalInicio.vue?vue&type=script&lang=js"
export * from "./PortalInicio.vue?vue&type=script&lang=js"

import "./PortalInicio.vue?vue&type=style&index=0&id=5513a3dc&scoped=true&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5513a3dc"]])

export default __exports__